<div class="card new-card m-0" [ngStyle]="{'min-height': vehicle.segment == 'CAR' && showAxleAndTire ? '335px' : ''}">
    <app-card-title title="Outras informações" icon="app-icon-negotiation"></app-card-title>
    <div class="info-container">
        <div class="info">
          <div class="label-container">
            <span class="label">Munícipio de registro</span>
          </div>
          <span class="value">{{vehicle?.registrationCity}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Solicitante</span>
          </div>
          <span class="value">{{vehicle.applicantName}}</span>
        </div>
        <div class="info">
          <div class="label-container">
            <span class="label">Comentários</span>
          </div>
          <span class="value">{{vehicle.description}}</span>
        </div>
      </div>
</div>